import React, { Component } from 'react';
import PropTypes from 'prop-types';
import APIManager from 'modules/common/apiManager';
import {
  Alert,
  ButtonCommonTheme,
  FormControl,
  Table,
  FormGroup,
  ControlLabel,
  ModalFooter,
  FormWrapper,
  FormColumn,
  ModalForm,
  ModalFormContainer
} from 'modules/theme';

class SIPExtensionAddEdit extends Component {
  constructor(props) {
    super(props);

    this.saveData = this.saveData.bind(this);
    this.renderFormGroup = this.renderFormGroup.bind(this);

    this.mAPI = new APIManager();
    if (this.props.editData && this.props.editData._id) {
      this.state = {
        sip: this.props.editData.sip,
        password: this.props.editData.password,
      };
    } else {
      this.state = {
        sip: '',
        password: '',
      };
    }
  }

  renderFormGroup(label, props) {
    return (
      <FormGroup>
        <ControlLabel required={props.required}>{label}</ControlLabel>
        <FormControl {...props} />
      </FormGroup>
    );
  }

  resetAllData() {
    this.setState({
      sip: '',
      password: '',
    });
  }

  apiResponse(errorCode, data) {
    if (errorCode === 201) {
      let message = data && data.message ? data.message : 'Successfully Done';
      Alert.success(`${message}`);
      this.resetAllData();
      this.props.closeModal(true);
    } else {
      let message =
        data && data.message ? data.message : 'Something wrong happened';
      Alert.error(`${message}`);
    }
  }
  saveData(e) {
    let _this = this;
    e.preventDefault();
    let tData = {
      sip: this.state.sip.trim() || '',
    };

    if (this.props.editData && this.props.editData._id) {
      this.mAPI.sendPostAPI(
        `setting/sip/${this.props.editData._id}`,
        {
          sip: this.state.sip.trim() || '',
          password: this.state.password,
        },
        (data) => {
          console.log(JSON.stringify(data, null, 2));
          if (data) {
            _this.resetAllData();
            _this.props.closeModal(true);
            Alert.success(`SIP Extension updated successfully.`);
          }
        },
        (errorCode, data) => {
          this.apiResponse(errorCode, data);
        },
        'private',
        { id: tData._id },
        'PUT'
      );
    } else {
      this.mAPI.sendPostAPI(
        'setting/sip',
        tData,
        (data) => {          
          Alert.success(`SIP Extension Created Successfully.`);
          this.resetAllData();
          this.props.update();
          this.props.closeModal(true);
        },
        (errorCode, data) => {
          this.apiResponse(errorCode, data);
        }
      );
    }
  }

  renderInfoData() {
    return (
      <Table whiteSpace='nowrap' bordered hover>
        <thead>
          <tr>
            <th>SIP</th>
            <th>Username</th>
            <th>Password</th>
          </tr>
        </thead>
        <tbody id='SIPExtensions'>
          <tr>
            <td>{this.props.infoData.sip}</td>
            <td>{this.props.infoData.userName}</td>
            <td>{this.props.infoData.password}</td>
          </tr>
        </tbody>
      </Table>
    );
  }

  renderAddEdit() {
    return (
      <FormWrapper>
        <FormColumn>
          {this.renderFormGroup('sip', {
            placeholder: 'sip',
            defaultValue: '',
            autoFocus: true,
            required: true,
            id: 'sip',
            value: this.state.sip,
            onChange: (e) => {
              if (e.target.value === ' ' || e.target.value.length > 70) {
                return false;
              }
              let agentName =
                e.target.value && e.target.value.trim() == ''
                  ? ''
                  : e.target.value;
              this.setState({ sip: agentName });
            },
          })}
        </FormColumn>
      </FormWrapper>
    );
  }

  render() {
    const { modalType } = this.props;

    return (
      <ModalForm onSubmit={(e) => this.saveData(e)}>
        <ModalFormContainer>
          {this.props.infoData && this.props.infoData._id
            ? this.renderInfoData()
            : this.renderAddEdit()}
        </ModalFormContainer>

        {this.props.infoData ? (
          <ModalFooter modalType={modalType}>
            <ButtonCommonTheme
              type='greyModalBtn'
              onClick={() => this.props.closeModal()}
              style={{ float: 'right' }}
            >
              Cancel
            </ButtonCommonTheme>
          </ModalFooter>
        ) : (
          <ModalFooter modalType={modalType}>
            <ButtonCommonTheme
              type='greyModalBtn'
              onClick={() => this.props.closeModal()}
            >
              Cancel
            </ButtonCommonTheme>
            <ButtonCommonTheme type='blueModalBtn' btnType='submit'>
              {this.props.editData && this.props.editData._id
                ? 'Update'
                : 'Add'}
            </ButtonCommonTheme>
          </ModalFooter>
        )}
      </ModalForm>
    );
  }
}

SIPExtensionAddEdit.propTypes = {
  group: PropTypes.array,
};

SIPExtensionAddEdit.contextTypes = {
  __: PropTypes.func,
};

export default SIPExtensionAddEdit;



// WEBPACK FOOTER //
// src/modules/screens/settings/SIPExtensions/components/SIPExtensionAddEdit.js